import { router } from '@inertiajs/react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card'
import { SupportHoursEditor, SupportHoursSchedule } from '@/components/SupportHoursEditor'
import routes from '@/routeHelpers'

interface SupportHoursOverrideCardProps {
  override: SupportHoursSchedule | null
  accountSchedule: SupportHoursSchedule | null
  effectiveTimezone: string
}

export function SupportHoursOverrideCard({ override, accountSchedule, effectiveTimezone }: SupportHoursOverrideCardProps) {
  const handleSave = (next: SupportHoursSchedule | null) => {
    router.patch(
      routes.profile.update.path(),
      { account_user: { support_hours: next ?? {} } },
      { preserveScroll: true },
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Your support hours (override)</CardTitle>
        <CardDescription>
          Override the account-wide hours for first-response analytics attributed to you. Useful if you cover different
          hours from the rest of your team — e.g. a different timezone, or different days off.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="text-xs text-muted-foreground">
          Times are in <span className="font-medium">{effectiveTimezone}</span> (your timezone).
        </div>
        <SupportHoursEditor
          value={override}
          onSave={handleSave}
          inheritedFrom={accountSchedule}
          inheritedLabel={accountSchedule ? 'the account-wide schedule' : '24/7'}
        />
      </CardContent>
    </Card>
  )
}
